module.exports = __webpack_public_path__ + "static/media/comprar-hero.2a05d271.svg";